import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/app/[locale]/error.tsx");
